import { render, staticRenderFns } from "./ChamadosAbertos.vue?vue&type=template&id=77c884ca&scoped=true"
import script from "./ChamadosAbertos.vue?vue&type=script&lang=js"
export * from "./ChamadosAbertos.vue?vue&type=script&lang=js"
import style0 from "./ChamadosAbertos.vue?vue&type=style&index=0&id=77c884ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c884ca",
  null
  
)

export default component.exports